import {
  Component,
  AfterViewInit,
  ElementRef,
  ViewChild,
  DestroyRef,
  inject
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { ListingService } from '../../../services/listing.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { firstValueFrom, fromEvent } from 'rxjs';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements AfterViewInit {

  loading = false;
  error = '';

  placementsData: { [key: string]: any[] } = {};

  placementLimits: { [key: string]: number } = {
    Homepage: 3,
    Sidebar: 3,
    DealsSection: 6,
  };

  uniqueCategories: string[] = [];

  @ViewChild('categoryScroll', { static: true })
  categoryScroll!: ElementRef<HTMLDivElement>;
  private destroyRef = inject(DestroyRef);

  constructor(
    private listingService: ListingService
  ) { }

  ngOnInit(): void {
    this.fetchListings();
  }

  ngAfterViewInit(): void {
    const el = this.categoryScroll.nativeElement;
    fromEvent<WheelEvent>(el, 'wheel')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(event => {
        if (event.deltaY === 0) return;

        event.preventDefault();
        el.scrollLeft += event.deltaY;
      });
  }

  async fetchListings() {
    this.loading = true;
    this.error = '';

    try {
      const result = await firstValueFrom(this.listingService.list());
      const records = result.records || [];

      // Latest first
      records.sort(
        (a: any, b: any) =>
          new Date(b.createdAt || b.timestampedAt).getTime() -
          new Date(a.createdAt || a.timestampedAt).getTime()
      );

      const categorySet = new Set<string>();
      this.placementsData = {};

      records.forEach((item: any) => {
        const placement = item.placement;
        const limit = this.placementLimits[placement] ?? Infinity;

        if (!this.placementsData[placement]) {
          this.placementsData[placement] = [];
        }

        if (this.placementsData[placement].length < limit) {
          this.placementsData[placement].push(item);
        }

        if (item.category) {
          categorySet.add(item.category.trim());
        }
      });

      this.uniqueCategories = Array.from(categorySet);

    } catch (err) {
      console.error(err);
      this.error = 'Failed to load data. Please try again.';
    } finally {
      this.loading = false;
    }
  }
}